module.exports = __webpack_public_path__ + "img/cold.6960c79d.svg";